import { FC, useState } from "react";
import { FormikHelpers } from "formik";
import {
  Form,
  Button,
  Modal,
  MessageField,
  FormButtons,
  useFileParser,
} from "@epcnetwork/core-ui-kit";

import { FormField } from "components";
import { MergeFileItem, MergeValues } from "../merge.types";
import { validationSchema } from "../merge.constants";

type MergeModalFormProps = {
  file: MergeFileItem;
  setClose: VoidFunction;
  onSubmitClick: (fileValues: MergeFileItem) => void;
};

export const MergeFormModal: FC<MergeModalFormProps> = ({ file, setClose, onSubmitClick }) => {
  const { loading, parsedFile, error } = useFileParser(file.originalFile);
  const [initialValues] = useState<MergeValues>({ headerValues: file.data });

  const onSubmit = (values: MergeValues, { setSubmitting }: FormikHelpers<MergeValues>) => {
    onSubmitClick({
      ...file,
      isTuned: true,
      data: { ...file.data, ...values.headerValues },
    });
    setSubmitting(false);
  };

  return (
    <Modal isOpen={Boolean(file)} setClose={setClose}>
      <h2>Set values {file.originalFile.name}</h2>
      <MessageField message={error} />
      <Form
        initialValues={initialValues}
        enableReinitialize
        onSubmit={onSubmit}
        loading={loading}
        validationSchema={validationSchema}
      >
        <FormField
          type="file-table"
          name="headerValues"
          label="Select Email column"
          parsedFile={parsedFile}
          loading={loading}
        />
        <FormButtons>
          <Button appearance="secondary" onClick={setClose}>
            Cancel
          </Button>
          <Button type="submit">Set values</Button>
        </FormButtons>
      </Form>
    </Modal>
  );
};
